export enum TCRBrandFriendlyRegistrationStatus {
  UNREGISTERED = 'Unregistered',
  PENDING = 'Pending',
  UNVERIFIED = 'Unverified',
  LOCKED = 'Locked',
  VERIFIED = 'Verified',
  SOLE_PROPRIETOR = 'Sole Proprietor',
  CANADA = 'Canada',
}
